import store from '@/store';
import {Module, getModule} from 'vuex-module-decorators';
import {DiagramModule} from '@/store/modules/diagramModule';

/*
    Динамический модуль хранилища vuex для работы с состояниями диаграмм
*/

const moduleName = 'spectrumDiagramModule';

@Module({
  name: moduleName,
  store: store,
  dynamic: true,
  namespaced: true,
})
class SpectrumDiagramModule extends DiagramModule {}

export default getModule(SpectrumDiagramModule);
